import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { CalibrationRunner } from '@features/calibration/CalibrationRunner';

const BenchCalibrationPage: React.FC = () => {
  const { dcRuntimeId } = useParams<{ dcRuntimeId: string }>();
  const { t } = useTranslation('calibration');

  return (
    <Box
      sx={{
        p: { xs: 2, sm: 3 },
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 3
      }}
    >
      <Typography variant="h5" fontWeight={600}>
        {t('bench.title', { defaultValue: 'Bench Calibration' })}
      </Typography>
      <CalibrationRunner dcRuntimeId={dcRuntimeId ?? ''} />
    </Box>
  );
};

export default BenchCalibrationPage;
